module.exports = "/_next/static/images/4686f0a8f3dc91eaa33b24c69a5dd555-woman-with-iphone-short-form@0.75x.jpg";